import type { AppStore } from "@src/stores/AppStore";
import type { BaseStore } from "@src/stores/BaseStore";
import type { TasksSettingsState } from "@src/stores/forms/SettingsModalState/TasksSettingsState";

export class TasksSettingsStore implements BaseStore {
  constructor(
    public appStore: AppStore,
    public form: TasksSettingsState,
  ) {}
}
